import { useMediaQuery, useTheme } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import OptionsButtonCustom from '../../../components/option-button/OptionsButtonCustom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { complaintReport, ReportApi } from '../../../api/report/Report.api';
import { saveAs } from 'file-saver';
import { alertActive, alertError, alertSuccess } from '../../../components/alert/swal';
import SwitchCustom from '../../../components/switch/SwitchCustom';
import { CommentApi } from '../../../api/comment/comment.api';
import { RootState } from '../../../store/store';
import { checkPermission } from '../../../utils/app.utils';

const ManageState = () => {
    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_WEBSITE_COMMENT', permission);

    const { t, i18n } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const dispatch = useDispatch();
    const [file, setFile] = useState<any>();
    const uploadRef = useRef<any>(null)
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [id_comment, set_id_comment] = useState<number | null>(null);
    const [status, set_status] = useState<string>("");

    const [showModal, setShowModal] = useState<string>("");

    const [data, setData] = useState<any[]>([]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);
    const [form, set_form] = useState<any>({
        comment_name: "",
        id_file: 0
    })


    const handleCloseModal = () => {
        setShowModal("");
        set_id_comment(null);
        set_form({ comment_name: "" })
        setFile(null)
    }
    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_comment", width: 100, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "center", label: t("ชื่อ-นามสกุล/ฉายา")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("ผู้สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("วันที่สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            comment_name,
            created_by,
            created_date,
            modified_date,
            modified_by,
            id_comment

        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: comment_name || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: modified_by || created_by || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? moment(modified_date).add(i18n.language === "en" ? 0 : 543, 'year').format("DD/MM/YYYY") : created_date ? moment(created_date).add(i18n.language === "en" ? 0 : 543, 'year').format("DD/MM/YYYY") : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <OptionsButtonCustom
                            enableEdit={checkPermit.isUpdate}
                            enableView={checkPermit.isView}
                            enableDelete={checkPermit.isDelete}
                            onViewClick={() => handleGetOneDetail(id_comment, 'VIEW')}
                            onEditClick={() => handleGetOneDetail(id_comment, 'EDIT')}
                            onDeleteClick={() => handleDeleteList(id_comment)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    // const handleChangeStatus = async (id_comment: number, st: boolean) => {
    //     const body: updateStatusType = {
    //         status: st ? COMPLAINT_TYPE_STATUS.INACTIVE : COMPLAINT_TYPE_STATUS.ACTIVE
    //     }
    //     dispatch(setLoading());
    //     await CommentApi.updateStatus(id_comment, body).then((res) => {
    //         if (res.status < 300) {
    //             handleGetData();
    //         }
    //     }).catch((err) => {
    //         alertError(t("COMPLAINTS_UPDATE_STATUS"), t("COMPLAINTS_UPDATE_STATUS_FAILED"))
    //         console.log(err)
    //     }).finally(() => {
    //         dispatch(unsetLoading());
    //     })
    // }
    const handleDeleteList = (id_comment: number) => {
        alertActive(t("ลบความคิดเห็น"), t("ต้องการลบความคิดเห็น หรือไม่?"), undefined, undefined, async () => {
            dispatch(setLoading());
            await CommentApi.deleteComment(id_comment).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("ลบความคิดเห็น"), t("ลบความคิดเห็น เรียบร้อยแล้ว"))
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ลบความคิดเห็น"), t("ลบความคิดเห็น ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, search: keyword }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        dispatch(setLoading());
        await CommentApi.getCommentList(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate])


    const handleGetOneDetail = async (id_comment: number, mode: string) => {
        setShowModal(mode);
        set_id_comment(id_comment)
        dispatch(setLoading());
        await CommentApi.getCommentById(id_comment).then((res) => {
            if (res.status < 300) {
                set_form(res.data?.data)
                setFile(`${res.data?.data.file_path}${res.data?.data.file_name}`)

            }
        }).catch((err) => console.log(err)).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleSubmitForm = async () => {
        dispatch(setLoading());
        if (id_comment) {
            await CommentApi.updateComment(id_comment, form).then((res) => {
                if (res.status < 300) {
                    //  if(file){
                    //     handleImportFileItem()
                    // }
                    alertSuccess(t("แก้ไขความคิดเห็น"), t('แก้ไขความคิดเห็น เรียบร้อยแล้ว'))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("แก้ไขความคิดเห็น"), t("แก้ไขความคิดเห็น ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await CommentApi.createComment(form).then((res) => {
                if (res.status < 300) {
                    // if(file){
                    //     handleImportFileItem()
                    // }
                    alertSuccess(t("เพิ่มความคิดเห็น"), t("เพิ่มความคิดเห็น เรียบร้อยแล้ว"))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("เพิ่มความคิดเห็น"), t("เพิ่มความคิดเห็น ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    const handleImportFileItem = async (file: any) => {
        const formData: FormData = new FormData();
        formData.append('file', file)
        // formData.append('id_employee', id)

        if (file) {
            dispatch(setLoading());
            await CommentApi.uploadCommentImage(formData).then((res) => {
                if (res.status < 300) {
                    set_form({ ...form, id_file: res.data.data?.id_comment_file })
                    console.log(res.data);
                    setFile(`${res.data.data.file_path}${res.data.data.file_name}`)
                    // alertSuccess("อัพโหลดไฟล์", "อัพโหลดไฟล์ เรียบร้อย", undefined, () => {
                    //     // window.location.reload()

                    // })
                } else {
                    alertError(t("อัพโหลดไฟล์"), t("อัพโหลดไฟล์ ไม่สำเร็จ"))
                }
                if (uploadRef.current) {
                    uploadRef.current.value = null;
                }
            }).catch((err) => {
                console.log(err);
                alertError(err?.response?.data?.message || t("อัพโหลดไฟล์ ไม่สำเร็จ"));
                if (uploadRef.current) {
                    uploadRef.current.value = null;
                }
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            return false;
        }
    }
    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        id_comment,
        set_id_comment,
        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmitForm,
        setShowModal,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        file,
        setFile,
        uploadRef,
        handleImportFileItem,
        checkPermit
    }
}

export default ManageState
